import { render, staticRenderFns } from "./OrgMediaLinks.vue?vue&type=template&id=4423520a&"
import script from "./OrgMediaLinks.vue?vue&type=script&lang=js&"
export * from "./OrgMediaLinks.vue?vue&type=script&lang=js&"
import style0 from "./OrgMediaLinks.vue?vue&type=style&index=0&id=4423520a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports